import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import $ from 'jquery';
import React, { Component } from 'react';
import { ApiUrl } from '../../services/ApiRest';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';

const urlListarEntidadF = ApiUrl + "entidad-formadora" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // URL corregida para que coincida con la API de Laravel
const urlIngresarEntidad = ApiUrl + "entidad-formadora" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para ingresar una nueva entidad
const urlDatosEntidad = ApiUrl + "entidad-formadora"; // Ruta para obtener los datos de la entidad
const urlModifDatosEntidad = ApiUrl + "entidad-formadora"; // Ruta para modificar datos de la entidad
const urlListarTutoresEntidad = ApiUrl + "entidad-formadora-tutores" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para listar los tutores
const urlIngresarTutor = ApiUrl + "entidad-formadora-tutores" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para agregar un nuevo tutor
const urlActualizarTutor = ApiUrl + "entidad-formadora-tutores"; // Ruta para actualizar un tutor
const urlListarDocumentosEntidad = ApiUrl + "entidad-formadora-documentos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para listar los documentos legales
const urlAgregarDocumentoEntidad = ApiUrl + "entidad-formadora-documentos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para agregar los documentos legales 
const urlModificarDocumentoEntidad = ApiUrl + "entidad-formadora-documentos"; // Ruta para modificar los documentos legales
const urlListarTiposDocumentos = ApiUrl + "tipos-documentos-legales" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"

let listaauxiliar = [];
const itemsPerPage = 10;

export default class ListEntidadPracticas extends Component {
    constructor(props) {
        super(props)

        this.state = {
            coordinacion: [],
            listaBackup: [],
            entidadSeleccionada: null, // entidad activa en detalle
            entidad_id: null,
            tutores: [], // tutores cargados de esa entidad
            documentos: [],
            tiposDocumentos: [],
            tipo_documento_id: '',


            form: {},
            form1: {},
            form2: {},

            // variables para paginación
            currentItems: null,
            selectedButton: null,
            selectedDetailButton: null,

            pageCount: 0,
            itemOffset: 0,
            count: 0,
            detallesVisibles: {},
            entidadBotones: {},

        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalIngresarCoord: false });
        }
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        console.log('entidad_id', this.state.entidad_id);
    }




    handleButtonClick = (buttonType, entityId) => {
        if (buttonType === 'modificar') {
            // Cuando se presiona Modificar: Ocultar los detalles si están visibles y limpiar el estado de detalles
            this.setState({
                selectedButton: { id: entityId, type: buttonType },
                selectedDetailButton: null, // Limpiar el detalle cuando se presiona Modificar
                detallesVisibles: {
                    ...this.state.detallesVisibles,
                    [entityId]: false,  // Ocultar el detalle de esta fila cuando se presiona modificar
                },
            });
        } else if (buttonType === 'detalle') {
            // Cuando se presiona Detalle: Alternar la visibilidad
            this.setState(prevState => {
                const isVisible = prevState.detallesVisibles[entityId];

                // Alternar la visibilidad de los detalles
                const updatedDetallesVisibles = Object.keys(prevState.detallesVisibles).reduce((acc, key) => {
                    if (key !== entityId) acc[key] = false; // Ocultamos todos los detalles excepto el que corresponde al entityId
                    else acc[key] = !isVisible; // Alternar la visibilidad
                    return acc;
                }, {});

                return {
                    selectedButton: null,  // Limpiar el estado del botón de modificar
                    selectedDetailButton: isVisible ? null : entityId, // Solo activar el detalle si no está visible
                    detallesVisibles: updatedDetallesVisibles, // Actualizamos la visibilidad
                };
            });
        } else if (buttonType === 'estado') {
            // Limpiar selección previa al presionar los botones de estado
            this.setState({
                selectedButton: null,  // Limpiar el botón de 'Modificar'
                selectedDetailButton: null, // Limpiar el detalle seleccionado
                detallesVisibles: {}, // Asegurarnos de que no haya detalles visibles
            });
        }
    };


    // Cambiar estado de la entidad
    bttActDesac = (entidad) => {
        // Alternamos el estado entre 0 (suspendido) y 1 (activo)
        let nuevoEstado = entidad.estado_entidad === 0 ? 1 : 0;

        // Realizamos la solicitud PUT para cambiar el estado
        axios.put(`${ApiUrl}entidad-formadora-estado${api_key}`, {
            id: entidad.id,  // Enviar el id de la entidad
            estado_entidad: nuevoEstado      // Enviar el nuevo estado
        })
            .then(response => {
                // Actualizamos el estado en el frontend con la respuesta de la API
                const updatedEntidad = response.data.data;

                // Actualizamos el estado de inmediato en el frontend
                this.setState(prevState => {
                    const updatedEntities = prevState.estud.map(entidad =>
                        entidad.id === updatedEntidad.id ? updatedEntidad : entidad
                    );

                    return {
                        estud: updatedEntities,  // Actualizamos las entidades
                        currentItems: updatedEntities.slice(prevState.itemOffset, prevState.itemOffset + itemsPerPage), // Actualizamos los elementos de la página actual
                        selectedButton: null  // Limpiar selección previa de 'modificar'
                    };
                });
            })
            .catch(error => {
                console.error("Error al cambiar el estado de la entidad", error);
            });
    };


    // Cambiar el estado de un tutor (Activo o Suspendido)
    bttActDesacTutor = (tutor) => {
        // Alternamos el estado entre 0 (Suspendido) y 1 (Activo)
        let nuevoEstado = tutor.estado_tutores_empresariales === 0 ? 1 : 0;

        // Realizamos la solicitud PUT para cambiar el estado
        axios.put(`${ApiUrl}tutores-empresariales-estado${api_key}`, {
            id: tutor.id,  // Enviar el ID del tutor
            estado_tutores_empresariales: nuevoEstado  // Enviar el nuevo estado
        })
            .then(response => {
                // Actualizamos el estado en el frontend con la respuesta de la API
                const updatedTutor = response.data.data;

                // Actualizamos el estado de inmediato en el frontend
                this.setState(prevState => {
                    const updatedTutors = prevState.tutores.map(tutor =>
                        tutor.id === updatedTutor.id ? updatedTutor : tutor
                    );

                    return { tutores: updatedTutors };  // Actualizamos la lista de tutores
                });
            })
            .catch(error => {
                console.error("Error al cambiar el estado del tutor", error);
                swal({
                    title: "Error",
                    text: "Hubo un error al actualizar el estado del tutor",
                    icon: "error",
                });
            });
    };


    // Cambiar estado del documento legal
    cambiarEstadoDocumento = (documento) => {
        // Alternar entre los estados 0, 1 y 2
        let nuevoEstado = documento.estado_documento_legal === 0 ? 1 : (documento.estado_documento_legal === 1 ? 2 : 0);

        axios.put(`${ApiUrl}documento-legal-estado${api_key}`, {
            id: documento.id,  // ID del documento legal
            estado_documento_legal: nuevoEstado  // Nuevo estado
        })
            .then(response => {
                // Actualizar el estado en el frontend con la respuesta de la API
                const updatedDocumento = response.data.data;

                // Actualizamos el estado en el frontend para reflejar el cambio
                this.setState(prevState => {
                    const updatedDocumentos = prevState.documentos.map(doc =>
                        doc.id === updatedDocumento.id ? updatedDocumento : doc
                    );

                    return { documentos: updatedDocumentos };  // Actualizamos la lista de documentos
                });
            })
            .catch(error => {
                console.error("Error al cambiar el estado del documento", error);
            });
    };



    componentDidMount() {
        axios.get(urlListarEntidadF)
            .then(response => {
                listaauxiliar = response.data;
                if (listaauxiliar != null) {
                    const estud = response.data;
                    this.setState({ estud: estud });
                    const ListaBackup = estud;
                    this.setState({ ListaBackup: ListaBackup });
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                } else {
                    swal({
                        title: "Advertencia",
                        text: "No existe información",
                        icon: "warning",
                    })
                }
            })

        this.cargarTiposDocumentos();
    }


    cargarTiposDocumentos = () => {
        axios.get(urlListarTiposDocumentos)
            .then(response => {
                if (response.data.success) {
                    this.setState({ tiposDocumentos: response.data.tipos_documentos });
                }
            })
            .catch(error => {
                console.error("Error al cargar tipos de documentos", error);
            });
    }

    // Modal de Ingreso de entidad
    modalAgregarEntidad = (registro) => {
        this.setState({ modalIngresarEntidad: true, form1: registro, detallesVisibles: {}, selectedButton: null });
    }

    ingresarDatosEntidad = () => {
        this.setState({ modalIngresarEntidad: false });
    }

    ocultarModalAgregarEntidad = () => {
        this.setState({ modalIngresarEntidad: false });
    }

    modalAgregarTutor = () => {
        this.setState({ modalIngresarTutor: true });
    };

    ocultarModalAgregarTutor = () => {
        this.setState({ modalIngresarTutor: false });
    };
    // Modal para ingresar documentos legales
    modalAgregarDocumento = () => {
        this.setState({
            modalIngresarDocumento: true,
            nombre_documento: '',
            fecha_inicio: '',
            fecha_final: '',
            responsable: '',
            tipo_documento_id: '', // Limpiar selección
            archivo: null
        });
    }

    ocultarModalAgregarDocumento = () => {
        this.setState({
            modalIngresarDocumento: false,
            archivo: null,  // Limpiar archivo cuando se cierra el modal
        });
    };


    // Modal para modificar documento legal
    modalModificarDocumento = (documento) => {
        this.setState({
            modalModificarDocumento: true,
            documentoSeleccionado: documento,
            nombre_documento: documento.nombre_documento_legal, // Cargar el nombre del documento
            fecha_inicio: documento.fecha_inicio_documento_legal, // Cargar la fecha de inicio
            fecha_final: documento.fecha_final_documento_legal, // Cargar la fecha final
            responsable: documento.responsable_documento_legal, // Cargar el responsable
            tipo_documento_id: documento.tipo_doc_legal_ent_id, // Cargar el tipo de documento
            archivo: null, // No pre-cargar el archivo aquí, ya que solo se enviará si se selecciona un nuevo archivo
        });
    };


    ocultarModalModificarDocumento = () => {
        this.setState({ modalModificarDocumento: false });
    };

    // Función para manejar la carga de archivo
    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ archivo: file });

        }
    };


    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
    };


    ingresarDatosDocumento = () => {
        // Validación de los campos requeridos
        if (!this.state.nombre_documento || !this.state.fecha_inicio || !this.state.fecha_final || !this.state.responsable || !this.state.tipo_documento_id || !this.state.archivo) {
            swal({
                text: "Por favor, complete todos los campos.",
                icon: "error",
                button: "Aceptar",
            });

            return;  // Evitar el envío si falta algún campo
        }

        const formData = new FormData();
        formData.append('nombre_documento_legal', this.state.nombre_documento);
        formData.append('fecha_inicio_documento_legal', this.state.fecha_inicio);
        formData.append('fecha_final_documento_legal', this.state.fecha_final);
        formData.append('responsable_documento_legal', this.state.responsable);
        formData.append('tipo_doc_legal_ent_id', this.state.tipo_documento_id);
        formData.append('archivo_documento_legal', this.state.archivo);  // Usar 'archivo' en lugar de 'documentomod'
        formData.append('entidad_id', this.state.entidad_id);

        // Realiza la solicitud para enviar el archivo
        axios.post(urlAgregarDocumentoEntidad, formData)
            .then(response => {
                if (response.data.success) {
                    swal({
                        text: "Documento agregado correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    this.setState({
                        archivo: null,  // Limpiar archivo después de agregar
                        modalIngresarDocumento: false,
                        nombre_documento: '', // Limpiar otros campos
                        fecha_inicio: '',
                        fecha_final: '',
                        responsable: '',
                        tipo_documento_id: '',
                    });
                    this.obtenerDocumentos();  // Recargar documentos
                } else {
                    swal({
                        text: "Hubo un error al agregar el documento",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                swal({
                    text: "Hubo un error al procesar la solicitud.",
                    icon: "error",
                    button: "Aceptar",
                });
            });

    };





    // Actualizar el documento legal
    actualizarDocumento = () => {
        // Primero mostramos la advertencia
        swal({
            title: "¿Está seguro que desea modificar los datos del DOCUMENTO LEGAL?",
            text: "Esta acción actualizará los datos del DOCUMENTO LEGAL.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willUpdate) => {
                if (willUpdate) {
                    // Si el usuario confirma, procedemos con la modificación del documento
                    if (!this.state.nombre_documento || !this.state.fecha_inicio || !this.state.fecha_final || !this.state.responsable || !this.state.tipo_documento_id) {
                        swal({
                            text: "Por favor, complete todos los campos.",
                            icon: "error",
                            button: "Aceptar",
                        });
                        return;
                    }

                    const formData = new FormData();

                    // Simular el método PUT para que Laravel lo reconozca
                    formData.append('_method', 'PUT');

                    // Agregar los campos del documento
                    formData.append('nombre_documento_legal', this.state.nombre_documento);
                    formData.append('fecha_inicio_documento_legal', this.state.fecha_inicio);
                    formData.append('fecha_final_documento_legal', this.state.fecha_final);
                    formData.append('responsable_documento_legal', this.state.responsable);
                    formData.append('tipo_doc_legal_ent_id', this.state.tipo_documento_id);

                    // Solo agregar el archivo si se seleccionó uno nuevo
                    if (this.state.archivo) {
                        formData.append('archivo_documento_legal', this.state.archivo);  // Solo se agrega si hay un nuevo archivo
                    }

                    // Realizar la solicitud PUT a la URL de modificación, solo si se tiene un documento seleccionado
                    if (this.state.documentoSeleccionado) {
                        axios.post(`${urlModificarDocumentoEntidad}/${this.state.documentoSeleccionado.id}${api_key}`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',  // Necesario para el envío de archivos
                            }
                        })
                            .then(response => {
                                if (response.data.success) {
                                    swal({
                                        text: "Documento modificado correctamente",
                                        icon: "success",
                                        button: "Aceptar",
                                    });

                                    // Limpiar los campos después de modificar el documento
                                    this.setState({
                                        archivo: null,
                                        modalModificarDocumento: false,
                                        nombre_documento: '',
                                        fecha_inicio: '',
                                        fecha_final: '',
                                        responsable: '',
                                        tipo_documento_id: '',
                                        documentoSeleccionado: null,
                                    });

                                    // Recargar los documentos actualizados
                                    this.obtenerDocumentos();
                                } else {
                                    swal({
                                        text: "Hubo un error al modificar el documento",
                                        icon: "error",
                                        button: "Aceptar",
                                    });
                                }
                            })
                            .catch(error => {
                                console.error("Error al modificar el documento", error);
                                swal({
                                    text: "Hubo un error al procesar la solicitud.",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                            });
                    } else {
                        swal({
                            text: "No se ha seleccionado un documento para modificar.",
                            icon: "error",
                            button: "Aceptar",
                        });
                    }
                } else {
                    // Si el usuario cancela la modificación
                    swal({
                        text: "¡Haz cancelado la modificación!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    };



    // Dentro de tu clase React
    modificarDocumento = (documento) => {
        this.setState({
            modalModificarDocumento: true,
            documentoSeleccionado: documento,
            nombre_documento: documento.nombre_documento_legal,
            fecha_inicio: documento.fecha_inicio_documento_legal,
            fecha_final: documento.fecha_final_documento_legal,
            responsable: documento.responsable_documento_legal,
            tipo_documento_id: documento.tipo_doc_legal_ent_id,
            archivo: null,  // No pre-cargar el archivo aquí
        });
    };

    // Ingresar nueva entidad
    ingresarDatosEntidad = () => {
        axios
            .post(urlIngresarEntidad, {
                ruc_entidad: this.state.ruc,
                nombre_entidad: this.state.nombre,
                represent_legal_ent: this.state.representante,
                direccion_entidad: this.state.direccion,
                ciudad_entidad: this.state.ciudad,
                telefono_entidad: this.state.telefono,
                actividad_entidad: this.state.actividad,
                estado_entidad: 1,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    axios.get(urlListarEntidadF)
                        .then(response => {
                            listaauxiliar = response.data;
                            if (listaauxiliar != null) {
                                const estud = response.data;
                                this.setState({ estud: estud });
                                const ListaBackup = estud;
                                this.setState({ ListaBackup: ListaBackup });
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                            } else {
                                swal({
                                    title: "Advertencia",
                                    text: "No existe información",
                                    icon: "warning",
                                })
                            }
                        })
                    this.setState({ modalIngresarEntidad: false });
                } else {
                    swal({
                        text: "Datos no actualizados",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalIngresarEntidad: false });
                }
            })
            .catch(error => {
                this.setState({ error: "No ha llenado correctamente los campos" });
                swal({
                    text: "No ha llenado correctamente los campos",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    obtenerTutores = () => {
        axios.get(urlListarTutoresEntidad, {
            params: { entidad_id: this.state.entidad_id },
        })
            .then(response => {
                this.setState({ tutores: response.data.tutores });
            })
            .catch(error => {
                console.error("Error al obtener los tutores", error);
                swal("Error", "No se pudieron obtener los tutores.", "error");
            });
    };

    obtenerDocumentos = () => {
        axios.get(urlListarDocumentosEntidad, {
            params: { entidad_id: this.state.entidad_id },
        })
            .then(response => {
                console.log("Response de documentos:", response.data); // Verificar la respuesta de la API
                if (response.data && response.data.documentos_legales) {
                    // Asignar número secuencial a los documentos
                    const documentosConNumero = response.data.documentos_legales.map((documento, index) => ({
                        ...documento,
                        numero: index + 1 // Asigna un número secuencial basado en el índice
                    }));
                    console.log("Documentos con número secuencial:", documentosConNumero); // Verificar si el número se asigna correctamente
                    this.setState({
                        documentos: documentosConNumero,  // Actualizar estado con documentos numerados
                    });
                } else {
                    this.setState({ documentos: [] });
                }
            })
            .catch(error => {
                console.error("Error al obtener los documentos legales", error);
                swal("Error", "No se pudieron obtener los documentos legales.", "error");
                this.setState({ documentos: [] });
            });
    };






    ingresarDatosTutor = () => {
        axios
            .post(urlIngresarTutor, {
                cedula_tutores_empresariales: this.state.cedula_tutor,
                nombres_tutores_empresariales: this.state.nombres_tutor,
                apellidos_tutores_empresariales: this.state.apellidos_tutor,
                cargo_tutores_empresariales: this.state.cargo_tutor,
                direccion_tutores_empresariales: this.state.direccion_tutor,
                telefono_tutores_empresariales: this.state.telefono_tutor,
                email_tutores_empresariales: this.state.email_tutor,
                estado_tutores_empresariales: this.state.estado_tutor,
                entidad_id: this.state.entidad_id,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    // Limpiar el formulario
                    this.setState({
                        cedula_tutor: '',
                        nombres_tutor: '',
                        apellidos_tutor: '',
                        cargo_tutor: '',
                        direccion_tutor: '',
                        telefono_tutor: '',
                        email_tutor: '',
                        estado_tutor: '',
                    });
                    this.setState({ modalIngresarTutor: false });
                    this.obtenerTutores(); // Para actualizar la lista de tutores
                } else {
                    swal({
                        text: "Datos no procesados",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalIngresarTutor: false });
                }
            })
            .catch(error => {
                swal({
                    text: "No ha llenado correctamente los campos",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    };




    // Modal para modificar la entidad // Función para mostrar los datos de la entidad en el modal
    modificarEntidad = (entidad) => {
        this.setState({ entidadSeleccionada: entidad.id });
        // Obtener los datos de la entidad desde el backend
        axios.get(`${urlDatosEntidad}/${entidad.id}${api_key}`)
            .then(res => {
                const EntidadF = res.data;
                this.setState({
                    rucmod: EntidadF.ruc_entidad,
                    nombremod: EntidadF.nombre_entidad,
                    representantemod: EntidadF.represent_legal_ent,
                    direccionmod: EntidadF.direccion_entidad,
                    ciudadmod: EntidadF.ciudad_entidad,
                    telefonomod: EntidadF.telefono_entidad,
                    actividadmod: EntidadF.actividad_entidad,
                    modalModEntidad: true, // Mostrar el modal
                    form2: entidad // Guardar la entidad seleccionada en el estado
                });
            });
    }

    // Función para manejar el envío del formulario de modificación
    actualizarEntidad = () => {
        // Primer confirmación
        swal({
            title: "¿Está seguro que desea modificar los datos?",
            text: "Esta acción actualizará los datos de la entidad.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willUpdate) => {
                if (willUpdate) {
                    // Si el usuario confirma, enviamos la actualización
                    axios.put(`${urlModifDatosEntidad}/${this.state.form2.id}${api_key}`, {
                        ruc_entidad: this.state.rucmod,
                        nombre_entidad: this.state.nombremod,
                        represent_legal_ent: this.state.representantemod,
                        direccion_entidad: this.state.direccionmod,
                        ciudad_entidad: this.state.ciudadmod,
                        telefono_entidad: this.state.telefonomod,
                        actividad_entidad: this.state.actividadmod,

                    })
                        .then(response => {
                            if (response.data.success) {
                                // Mostrar mensaje de éxito
                                swal({
                                    text: response.data.message,  // Mostrar el mensaje específico
                                    icon: "success",
                                    button: "Aceptar",
                                });

                                // Cerrar el modal
                                this.setState({ modalModEntidad: false });

                                // Actualizar la lista de entidades en el estado
                                const updatedEntidad = response.data.data;

                                // Actualizamos directamente la lista de entidades
                                this.setState(prevState => {
                                    const updatedEntities = prevState.estud.map(entidad =>
                                        entidad.id === updatedEntidad.id ? updatedEntidad : entidad
                                    );

                                    // Actualizamos la paginación también
                                    const itemsPerPage = 2;  // Define los items por página
                                    const startIndex = prevState.itemOffset;
                                    const endIndex = startIndex + itemsPerPage;
                                    const currentItems = updatedEntities.slice(startIndex, endIndex);

                                    return {
                                        estud: updatedEntities,
                                        currentItems,  // Actualizamos los elementos de la página actual
                                        pageCount: Math.ceil(updatedEntities.length / itemsPerPage) // Actualizamos el total de páginas
                                    };
                                });

                            } else {
                                // Mostrar mensaje de error si no se actualizó
                                swal({
                                    text: "Datos no actualizados",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                            }
                        })
                        .catch(error => {
                            swal({
                                text: "No ha llenado correctamente los campos",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                } else {
                    // Si el usuario cancela la confirmación
                    swal({
                        text: "¡Acción cancelada!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    modificarTutor = (tutor) => {
        this.setState({
            // Establecer los datos del tutor en el estado para que se muestren en los campos del modal
            cedula_tutor: tutor.cedula_tutores_empresariales,
            nombres_tutor: tutor.nombres_tutores_empresariales,
            apellidos_tutor: tutor.apellidos_tutores_empresariales,
            cargo_tutor: tutor.cargo_tutores_empresariales,
            direccion_tutor: tutor.direccion_tutores_empresariales,
            telefono_tutor: tutor.telefono_tutores_empresariales,
            email_tutor: tutor.email_tutores_empresariales,
            estado_tutor: tutor.estado_tutores_empresariales,
            tutor_id: tutor.id,  // Guardar el ID del tutor para la actualización
            modalModTutor: true,  // Abrir el modal de modificación
        });
    };

    actualizarTutor = () => {
        // Confirmación antes de realizar la actualización
        swal({
            title: "¿Está seguro que desea modificar los datos del tutor?",
            text: "Esta acción actualizará los datos del tutor.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willUpdate) => {
                if (willUpdate) {
                    // Si el usuario confirma la acción, realizamos la actualización en el backend
                    axios.put(`${urlActualizarTutor}/${this.state.tutor_id}${api_key}`, {
                        cedula_tutores_empresariales: this.state.cedula_tutor,
                        nombres_tutores_empresariales: this.state.nombres_tutor,
                        apellidos_tutores_empresariales: this.state.apellidos_tutor,
                        cargo_tutores_empresariales: this.state.cargo_tutor,
                        direccion_tutores_empresariales: this.state.direccion_tutor,
                        telefono_tutores_empresariales: this.state.telefono_tutor,
                        email_tutores_empresariales: this.state.email_tutor,
                        estado_tutores_empresariales: 1,
                    })
                        .then(response => {
                            if (response.data.success) {
                                swal({
                                    text: "Tutor actualizado correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });

                                // Cerrar el modal
                                this.setState({ modalModTutor: false });

                                // Actualizar la lista de tutores
                                this.obtenerTutores(); // Para actualizar la lista de tutores después de la modificación
                            } else {
                                swal({
                                    text: "No se pudo actualizar el tutor",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                            }
                        })
                        .catch(error => {
                            swal({
                                text: "Hubo un error al actualizar los datos del tutor",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                } else {
                    swal({
                        text: "¡Haz cancelado la modificación!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    };


    verDetalle = (entidad) => {
        this.setState({
            entidad_id: entidad.id  // Guardamos el entidad_id de la entidad seleccionada
        });

        // Obtener los tutores de la entidad
        axios.get(urlListarTutoresEntidad, {
            params: { entidad_id: entidad.id },  // Enviar el ID de la entidad
        })
            .then(response => {
                this.setState(prevState => ({
                    tutores: response.data.tutores, // Los tutores de la entidad
                    entidadSeleccionada: entidad.id, // Establecer la entidad seleccionada
                    detallesVisibles: {
                        ...prevState.detallesVisibles,
                        [entidad.id]: !prevState.detallesVisibles[entidad.id], // Alternar visibilidad
                    }
                }));
            })
            .catch(error => {
                console.error("Error al obtener los tutores", error);
                swal("Error", "No se pudieron obtener los tutores.", "error");
            });

        // Obtener los documentos de la entidad
        axios.get(urlListarDocumentosEntidad, {
            params: { entidad_id: entidad.id },  // Asegúrate de enviar el ID correcto
        })
            .then(response => {
                console.log("Documentos recibidos: ", response.data);  // Verifica los documentos que recibes
                if (response.data && response.data.documentos_legales) {
                    this.setState({
                        documentos: response.data.documentos_legales,  // Guardamos los documentos en el estado
                    });
                } else {
                    this.setState({ documentos: [] });  // Si no hay documentos, lo dejamos vacío
                }
            })
            .catch(error => {
                console.error("Error al obtener los documentos legales", error);
                swal("Error", "No se pudieron obtener los documentos legales.", "error");
                this.setState({ documentos: [] });
            });
    };








    // Función de búsqueda
    filter(event) {
        const text = event.target.value;
        const data = this.state.estud;
        let newData = data.filter(function (item) {
            const itemDataNomCentro = item.ruc_entidad.toUpperCase();
            const itemDataRepresentante = item.nombre_entidad.toUpperCase();
            const itemDataSupervisor = item.ciudad_entidad.toUpperCase();
            const campo = itemDataNomCentro + " " + itemDataRepresentante + " " + itemDataSupervisor;
            const textData = text.toUpperCase();
            return campo.indexOf(textData) > -1;
        });

        if (text === "") {
            newData = this.state.ListaBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        });
    }

    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset };
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ ListaBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    {/* Encabezado principal */}
                    <div className="back-istmas">
                        <i className="fa fa-file-alt bounce-custom fs-5"></i>
                        <b className="ms-2">Entidades Formadoras</b>
                    </div>

                    <div className="p-3 rounded-3 mt-3">
                        {/* Buscador */}
                        <div className="row mb-3">
                            <div className="col-12 col-sm-12 col-lg-4 text-azul">
                                <label className="form-label">
                                    <b><i className="fa-magnifying-glass"></i> Buscar:</b>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar por RUC, institución o representante..."
                                    onChange={(e) => this.filter(e)}
                                />
                            </div>
                        </div>

                        {/* Tabla de Entidades */}
                        <div className="table-responsive">
                            <table className="table table-hover table-sm-custom">
                                <thead className="table-light">
                                    <tr className="text-azul text-center">
                                        <th>RUC</th>
                                        <th>Institución</th>
                                        <th>Representante</th>
                                        <th>Dirección</th>
                                        <th>Ciudad</th>
                                        <th>Teléfono</th>
                                        <th>Actividad</th>
                                        <th>Estado</th>
                                        <th>Modificar</th>
                                        <th>Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.length > 0 ? (
                                        this.state.currentItems.map((consola) => (
                                            <tr
                                                key={consola.id}
                                                className={`text-azul text-center ${this.state.entidadSeleccionada === consola.id ? 'bg-light' : ''
                                                    }`}
                                            >
                                                <td>{consola.ruc_entidad}</td>
                                                <td>{consola.nombre_entidad}</td>
                                                <td>{consola.represent_legal_ent}</td>
                                                <td>{consola.direccion_entidad}</td>
                                                <td>{consola.ciudad_entidad}</td>
                                                <td>{consola.telefono_entidad}</td>
                                                <td>{consola.actividad_entidad}</td>
                                                <td>
                                                    {(() => {
                                                        switch (consola.estado_entidad) {
                                                            case 0:
                                                                return (
                                                                    <span
                                                                        className="badge bg-danger text-white px-2 py-1"
                                                                        style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                        onClick={() => this.bttActDesac(consola)}
                                                                    >
                                                                        Inactivo
                                                                    </span>
                                                                );
                                                            case 1:
                                                                return (
                                                                    <span
                                                                        className="badge bg-success text-white px-2 py-1"
                                                                        style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                        onClick={() => this.bttActDesac(consola)}
                                                                    >
                                                                        Activo
                                                                    </span>
                                                                );
                                                            default:
                                                                return null;
                                                        }
                                                    })()}
                                                </td>

                                                {/* Botón Modificar */}
                                                <td className="text-center">
                                                    <button
                                                        className={`btn btn-link p-0 ${this.state.selectedButton?.id === consola.id &&
                                                            this.state.selectedButton?.type === 'modificar'
                                                            ? 'text-primary'
                                                            : 'text-azul'
                                                            }`}
                                                        onClick={() => {
                                                            this.handleButtonClick('modificar', consola.id);
                                                            this.modificarEntidad(consola);
                                                        }}
                                                        title="Modificar entidad"
                                                    >
                                                        <i className="fas fa-pen"></i>
                                                    </button>
                                                </td>

                                                {/* Botón Detalle */}
                                                <td className="text-center">
                                                    <button
                                                        className={`btn btn-link p-0 ${this.state.selectedDetailButton === consola.id
                                                            ? 'text-primary'
                                                            : 'text-azul'
                                                            }`}
                                                        onClick={() => {
                                                            this.handleButtonClick('detalle', consola.id);
                                                            this.verDetalle(consola);
                                                        }}
                                                        title="Ver detalle"
                                                    >
                                                        <i className="fas fa-eye"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted py-3">
                                                No existen entidades formadoras registradas.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginación */}
                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                pageCount={this.state.pageCount}
                                onPageChange={this.handlePageClick}
                                containerClassName="pagination pagination-sm-custom"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                            />
                        </div>

                        {/* Botón Agregar Entidad */}
                        <div className="text-center mt-3">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                onClick={(e) => this.modalAgregarEntidad(e)}
                            >
                                <i className="fas fa-plus me-1"></i>Agregar entidad
                            </button>
                        </div>

                        {/* ===================== TUTORES EMPRESARIALES ===================== */}
                        {this.state.detallesVisibles[this.state.entidadSeleccionada] && (
                            <div className="card mt-4 shadow-sm border-0 animate__animated animate__fadeIn">
                                <div className="back-istmas">
                                    <i className="fa fa-users bounce-custom fs-5"></i>
                                    <b className="ms-2">Tutores empresariales</b>
                                </div>

                                <div className="p-3">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-sm-custom">
                                            <thead className="table-light">
                                                <tr className="text-azul text-center">
                                                    <th>Cédula</th>
                                                    <th>Nombres</th>
                                                    <th>Apellidos</th>
                                                    <th>Cargo</th>
                                                    <th>Dirección</th>
                                                    <th>Teléfono</th>
                                                    <th>Correo</th>
                                                    <th>Estado</th>
                                                    <th>Modificar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.tutores && this.state.tutores.length > 0 ? (
                                                    this.state.tutores.map((tutor) => (
                                                        <tr
                                                            key={tutor.id}
                                                            className={`text-azul text-center ${this.state.selectedTutor === tutor.id ? 'bg-light' : ''}`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.setState({ selectedTutor: tutor.id })}
                                                        >
                                                            <td>{tutor.cedula_tutores_empresariales}</td>
                                                            <td>{tutor.nombres_tutores_empresariales}</td>
                                                            <td>{tutor.apellidos_tutores_empresariales}</td>
                                                            <td>{tutor.cargo_tutores_empresariales}</td>
                                                            <td>{tutor.direccion_tutores_empresariales}</td>
                                                            <td>{tutor.telefono_tutores_empresariales}</td>
                                                            <td>{tutor.email_tutores_empresariales}</td>
                                                            <td>
                                                                {tutor.estado_tutores_empresariales === 1 ? (
                                                                    <span
                                                                        className="badge bg-success text-white px-2 py-1"
                                                                        style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                        onClick={() => this.bttActDesacTutor(tutor)}
                                                                    >
                                                                        Activo
                                                                    </span>
                                                                ) : (
                                                                    <span
                                                                        className="badge bg-danger text-white px-2 py-1"
                                                                        style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                        onClick={() => this.bttActDesacTutor(tutor)}
                                                                    >
                                                                        Inactivo
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-link p-0 text-azul"
                                                                    onClick={() => this.modificarTutor(tutor)}
                                                                    title="Modificar tutor"
                                                                >
                                                                    <i className="fas fa-pen"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center text-muted py-3">
                                                            No hay tutores empresariales disponibles para esta entidad formadora.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="text-center mt-2 mb-2">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                            onClick={this.modalAgregarTutor}
                                        >
                                            <i className="fas fa-plus me-1"></i>Agregar tutor empresarial
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ===================== DOCUMENTOS LEGALES ===================== */}
                        {this.state.detallesVisibles[this.state.entidadSeleccionada] && (
                            <div className="card mt-4 shadow-sm border-0 animate__animated animate__fadeIn">
                                <div className="back-istmas">
                                    <i className="fa fa-file-contract bounce-custom fs-5"></i>
                                    <b className="ms-2">Documentos legales</b>
                                </div>

                                <div className="p-3">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-sm-custom">
                                            <thead className="table-light">
                                                <tr className="text-azul text-center">
                                                    <th>N°</th>
                                                    <th>Nombre documento</th>
                                                    <th>Fecha inicio</th>
                                                    <th>Fecha final</th>
                                                    <th>Responsable</th>
                                                    <th>Tipo documento</th>
                                                    <th>Archivo</th>
                                                    <th>Estado</th>
                                                    <th>Modificar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.documentos && this.state.documentos.length > 0 ? (
                                                    this.state.documentos.map((documento) => (
                                                        <tr
                                                            key={documento.id}
                                                            className={`text-azul text-center ${this.state.selectedButton?.id === documento.id &&
                                                                this.state.selectedButton?.type === 'modificar'
                                                                ? 'bg-light'
                                                                : ''
                                                                }`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() =>
                                                                this.setState({
                                                                    selectedButton: { id: documento.id, type: 'modificar' },
                                                                })
                                                            }
                                                        >
                                                            <td>{documento.numero}</td>
                                                            <td>{documento.nombre_documento_legal}</td>
                                                            <td>{documento.fecha_inicio_documento_legal}</td>
                                                            <td>{documento.fecha_final_documento_legal}</td>
                                                            <td>{documento.responsable_documento_legal}</td>
                                                            <td>
                                                                {documento.tipo_doc_legal_ent
                                                                    ? documento.tipo_doc_legal_ent.nombre_tipo_doc_legal_ent
                                                                    : 'N/A'}
                                                            </td>
                                                            <td>
                                                                {documento.ruta_archivo && (
                                                                    <a href={documento.ruta_archivo} target="_blank" rel="noreferrer">
                                                                        <i className="fa fa-2x fa-file-alt text-primary"></i>
                                                                    </a>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    switch (documento.estado_documento_legal) {
                                                                        case 0:
                                                                            return (
                                                                                <span
                                                                                    className="badge bg-danger text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                                    onClick={() => this.cambiarEstadoDocumento(documento)}
                                                                                >
                                                                                    Inactivo
                                                                                </span>
                                                                            );
                                                                        case 1:
                                                                            return (
                                                                                <span
                                                                                    className="badge bg-success text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                                    onClick={() => this.cambiarEstadoDocumento(documento)}
                                                                                >
                                                                                    Activo
                                                                                </span>
                                                                            );
                                                                        case 2:
                                                                            return (
                                                                                <span
                                                                                    className="badge bg-secondary text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem" }}
                                                                                    onClick={() => this.cambiarEstadoDocumento(documento)}
                                                                                >
                                                                                    Dado de baja
                                                                                </span>
                                                                            );
                                                                        default:
                                                                            return null;
                                                                    }
                                                                })()}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-link p-0 text-azul"
                                                                    onClick={() => this.modificarDocumento(documento)}
                                                                    title="Modificar documento"
                                                                >
                                                                    <i className="fas fa-pen"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center text-muted py-3">
                                                            No hay documentos legales disponibles para esta entidad formadora.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="text-center mt-2 mb-2">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                            onClick={this.modalAgregarDocumento}
                                        >
                                            <i className="fas fa-plus me-1"></i>Agregar documento legal
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <Modal isOpen={this.state.modalIngresarDocumento} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Agregar Nuevo Documento Legal</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}>
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, ingrese los datos requeridos para agregar un documento legal.</p>
                                <FormGroup>
                                    <label className="form-label">Nombre del Documento <span className="text-danger">*</span></label>
                                    <input type="text" id="nombre_documento" name="nombre_documento" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Contrato de Capacitación" />
                                    <label className="form-label mt-3">Fecha de Inicio <span className="text-danger">*</span></label>
                                    <input type="date" id="fecha_inicio" name="fecha_inicio" className="form-control" onChange={this.handleChange} required />
                                    <label className="form-label mt-3">Fecha de Finalización <span className="text-danger">*</span></label>
                                    <input type="date" id="fecha_final" name="fecha_final" className="form-control" onChange={this.handleChange} required />
                                    <label className="form-label mt-3">Responsable <span className="text-danger">*</span><span className="text-danger">*</span></label>
                                    <input type="text" id="responsable" name="responsable" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Juan Pérez" />
                                    <label className="form-label mt-3">Tipo de Documento <span className="text-danger">*</span></label>
                                    <select
                                        name="tipo_documento_id"
                                        className="form-control"
                                        value={this.state.tipo_documento_id}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">-- Seleccione un tipo de documento --</option>
                                        {this.state.tiposDocumentos.map((tipo) => (
                                            <option
                                                key={tipo.id}
                                                value={tipo.id}
                                            >
                                                {tipo.nombre_tipo_doc_legal_ent}
                                            </option>
                                        ))}
                                    </select>
                                    <label className="form-label mt-3">Cargar Archivo <span className="text-danger">*</span></label>
                                    <input type="file" className="form-control" onChange={this.handleFileChange} required accept=".pdf,.docx,.xlsx" />
                                    {this.state.archivo && !this.state.cargadoExitosamente && (<input type="text" className="form-control mt-2" value="¡Documento Cargado Exitosamente!" readOnly style={{ textAlign: 'center', color: 'green', backgroundColor: '#f8f9fa', border: '1px solid #ced4da' }} />)}
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button className="btn btn-outline-success" onClick={this.ingresarDatosDocumento}><i className="fas fa-save"></i> Guardar</button>
                                <button className="btn btn-outline-danger" onClick={this.ocultarModalAgregarDocumento}><i className="fas fa-times"></i> Cancelar</button>
                            </ModalFooter>
                        </Modal>
                        {/* Modal para modificar un documento legal */}
                        <Modal isOpen={this.state.modalModificarDocumento} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Modificar Documento Legal</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}>
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, ingrese los datos requeridos para modificar un documento legal.</p>
                                <FormGroup>
                                    <label className="form-label">Nombre del Documento <span className="text-danger">*</span></label>
                                    <input type="text" id="nombre_documento" name="nombre_documento" className="form-control" onChange={this.handleChange} value={this.state.nombre_documento} required placeholder="Ejemplo: Contrato de Capacitación" />
                                    <label className="form-label mt-3">Fecha de Inicio <span className="text-danger">*</span></label>
                                    <input type="date" id="fecha_inicio" name="fecha_inicio" className="form-control" onChange={this.handleChange} value={this.state.fecha_inicio} required />
                                    <label className="form-label mt-3">Fecha de Finalización <span className="text-danger">*</span></label>
                                    <input type="date" id="fecha_final" name="fecha_final" className="form-control" onChange={this.handleChange} value={this.state.fecha_final} required />
                                    <label className="form-label mt-3">Responsable <span className="text-danger">*</span></label>
                                    <input type="text" id="responsable" name="responsable" className="form-control" onChange={this.handleChange} value={this.state.responsable} required placeholder="Ejemplo: Juan Pérez" />
                                    {/* SELECT para Tipo de Documento */}
                                    <label className="form-label mt-3">Tipo de Documento <span className="text-danger">*</span></label>
                                    <select
                                        name="tipo_documento_id"
                                        className="form-control"
                                        value={this.state.tipo_documento_id}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">-- Seleccione un tipo de documento --</option>
                                        {this.state.tiposDocumentos.map((tipo) => (
                                            <option
                                                key={tipo.id}
                                                value={tipo.id}
                                            >
                                                {tipo.nombre_tipo_doc_legal_ent}
                                            </option>
                                        ))}
                                    </select>
                                    <label className="form-label mt-3">Cargar Archivo <span className="text-danger">*</span></label>
                                    <input type="file" className="form-control mb-3" onChange={this.handleFileChange} accept=".pdf,.docx,.xlsx" />
                                    <input type="text" className="form-control" value={this.state.documentoSeleccionado ? this.state.documentoSeleccionado.archivo_documento_legal : ''} readOnly placeholder="Archivo no seleccionado" />


                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button className="btn btn-outline-success" onClick={this.actualizarDocumento}><i className="fas fa-save"></i> Guardar</button>
                                <button className="btn btn-outline-danger" onClick={this.ocultarModalModificarDocumento}><i className="fas fa-times"></i> Cancelar</button>
                            </ModalFooter>
                        </Modal>

                        {/* Modal para ingresar datos de entidad formadora */}
                        <Modal isOpen={this.state.modalIngresarEntidad} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Agregar Nueva Entidad Formadora</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}> {/* Aumenta la altura y el padding */}
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, ingrese los datos requeridos para agregar una nueva entidad formadora.</p>

                                <FormGroup>
                                    <div className="d-flex justify-content-between">
                                        <div className="w-48">
                                            <label className="form-label">RUC <span className="text-danger">*</span></label>
                                            <input type="text" id="ruc" name="ruc" className="form-control rounded-input" onChange={this.handleChange} required placeholder="Ejemplo: 1234567890" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">INSTITUCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="nombre" name="nombre" className="form-control rounded-input" onChange={this.handleChange} required placeholder="Ejemplo: Centro de Formación XYZ" />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">REPRESENTANTE <span className="text-danger">*</span></label>
                                            <input type="text" id="representante" name="representante" className="form-control rounded-input" onChange={this.handleChange} required placeholder="Ejemplo: Juan Pérez" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">DIRECCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="direccion" name="direccion" className="form-control rounded-input" onChange={this.handleChange} required placeholder="Ejemplo: Av. Principal 123" />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">CIUDAD <span className="text-danger">*</span></label>
                                            <input type="text" id="ciudad" name="ciudad" className="form-control rounded-input" onChange={this.handleChange} placeholder="Ejemplo: Quito" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">TELÉFONO <span className="text-danger">*</span></label>
                                            <input type="text" id="telefono" name="telefono" className="form-control rounded-input" onChange={this.handleChange} placeholder="Ejemplo: 0222334455" />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">ACTIVIDAD <span className="text-danger">*</span></label>
                                            <input type="text" id="actividad" name="actividad" className="form-control rounded-input" onChange={this.handleChange} placeholder="Ejemplo: Capacitación empresarial" />
                                        </div></div>
                                </FormGroup>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-outline-success rounded-btn" onClick={() => this.ingresarDatosEntidad()}>
                                    <i className="fas fa-save"></i> Guardar
                                </button>
                                <button className="btn btn-outline-danger rounded-btn" onClick={this.ocultarModalAgregarEntidad}>
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                            </ModalFooter>
                        </Modal>
                        {/* Modal para modificar datos de entidad formadora */}
                        <Modal isOpen={this.state.modalModEntidad} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Modificar Entidad Formadora</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}>
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, actualice los datos de la entidad formadora seleccionada.</p>
                                <FormGroup>
                                    <div className="d-flex justify-content-between">
                                        <div className="w-48">
                                            <label className="form-label">RUC <span className="text-danger">*</span></label>
                                            <input type="text" id="rucmod" name="rucmod" className="form-control" value={this.state.rucmod} onChange={this.handleChange} required placeholder="Ejemplo: 1234567890" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">INSTITUCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="nombremod" name="nombremod" className="form-control" value={this.state.nombremod} onChange={this.handleChange} required placeholder="Ejemplo: Centro de Formación XYZ" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">REPRESENTANTE <span className="text-danger">*</span></label>
                                            <input type="text" id="representantemod" name="representantemod" className="form-control" value={this.state.representantemod} onChange={this.handleChange} required placeholder="Ejemplo: Juan Pérez" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">DIRECCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="direccionmod" name="direccionmod" className="form-control" value={this.state.direccionmod} onChange={this.handleChange} placeholder="Ejemplo: Av. Principal 123" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">CIUDAD <span className="text-danger">*</span></label>
                                            <input type="text" id="ciudadmod" name="ciudadmod" className="form-control" value={this.state.ciudadmod} onChange={this.handleChange} placeholder="Ejemplo: Quito" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">TELÉFONO <span className="text-danger">*</span></label>
                                            <input type="text" id="telefonomod" name="telefonomod" className="form-control" value={this.state.telefonomod} onChange={this.handleChange} placeholder="Ejemplo: 0222334455" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">ACTIVIDAD <span className="text-danger">*</span></label>
                                            <input type="text" id="actividadmod" name="actividadmod" className="form-control" value={this.state.actividadmod} onChange={this.handleChange} placeholder="Ejemplo: Capacitación empresarial" />
                                        </div>
                                    </div>
                                </FormGroup>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-outline-success" onClick={this.actualizarEntidad}>
                                    <i className="fas fa-save"></i> Guardar
                                </button>
                                <button className="btn btn-outline-danger" onClick={() => this.setState({ modalModEntidad: false })}>
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                            </ModalFooter>
                        </Modal>

                        {/* Modal para ingresar datos de Tutor Empresarial */}
                        <Modal isOpen={this.state.modalIngresarTutor} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Agregar Nuevo Tutor Empresarial</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}>
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, ingrese los datos requeridos para agregar un nuevo tutor empresarial.</p>

                                <FormGroup>
                                    <div className="d-flex justify-content-between">
                                        <div className="w-48">
                                            <label className="form-label">CÉDULA <span className="text-danger">*</span></label>
                                            <input type="text" id="cedula_tutor" name="cedula_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: 1234567890" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">NOMBRES <span className="text-danger">*</span></label>
                                            <input type="text" id="nombres_tutor" name="nombres_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Juan" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">APELLIDOS <span className="text-danger">*</span></label>
                                            <input type="text" id="apellidos_tutor" name="apellidos_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Pérez" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">CARGO <span className="text-danger">*</span></label>
                                            <input type="text" id="cargo_tutor" name="cargo_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Coordinador" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">DIRECCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="direccion_tutor" name="direccion_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: Av. Principal 123" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">TELÉFONO <span className="text-danger">*</span></label>
                                            <input type="text" id="telefono_tutor" name="telefono_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: 0222334455" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">EMAIL <span className="text-danger">*</span></label>
                                            <input type="email" id="email_tutor" name="email_tutor" className="form-control" onChange={this.handleChange} required placeholder="Ejemplo: tutor@correo.com" />
                                        </div>
                                    </div>
                                </FormGroup>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-outline-success" onClick={this.ingresarDatosTutor}>
                                    <i className="fas fa-save"></i> Guardar
                                </button>
                                <button className="btn btn-outline-danger" onClick={this.ocultarModalAgregarTutor}>
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                            </ModalFooter>
                        </Modal>

                        {/* Modal para modificar datos de Tutor Empresarial */}
                        <Modal isOpen={this.state.modalModTutor} size="md" centered>
                            <ModalHeader style={{ backgroundColor: '#8bc34e', color: '#fff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                <h5 className="text-center">Modificar Tutor Empresarial</h5>
                            </ModalHeader>
                            <ModalBody style={{ minHeight: '400px', padding: '1rem' }}>
                                <p className="text-center text-muted" style={{ marginBottom: '20px' }}>Por favor, ingrese los datos requeridos para modificar el tutor empresarial.</p>

                                <FormGroup>
                                    <div className="d-flex justify-content-between">
                                        <div className="w-48">
                                            <label className="form-label">CÉDULA <span className="text-danger">*</span></label>
                                            <input type="text" id="cedula_tutor" name="cedula_tutor" className="form-control" value={this.state.cedula_tutor} onChange={this.handleChange} required placeholder="Ejemplo: 1234567890" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">NOMBRES <span className="text-danger">*</span></label>
                                            <input type="text" id="nombres_tutor" name="nombres_tutor" className="form-control" value={this.state.nombres_tutor} onChange={this.handleChange} required placeholder="Ejemplo: Juan" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">APELLIDOS <span className="text-danger">*</span></label>
                                            <input type="text" id="apellidos_tutor" name="apellidos_tutor" className="form-control" value={this.state.apellidos_tutor} onChange={this.handleChange} required placeholder="Ejemplo: Pérez" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">CARGO <span className="text-danger">*</span></label>
                                            <input type="text" id="cargo_tutor" name="cargo_tutor" className="form-control" value={this.state.cargo_tutor} onChange={this.handleChange} required placeholder="Ejemplo: Coordinador" />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">DIRECCIÓN <span className="text-danger">*</span></label>
                                            <input type="text" id="direccion_tutor" name="direccion_tutor" className="form-control" value={this.state.direccion_tutor} onChange={this.handleChange} required placeholder="Ejemplo: Av. Principal 123" />
                                        </div>
                                        <div className="w-48">
                                            <label className="form-label">TELÉFONO <span className="text-danger">*</span></label>
                                            <input type="text" id="telefono_tutor" name="telefono_tutor" className="form-control" value={this.state.telefono_tutor} onChange={this.handleChange} required placeholder="Ejemplo: 0222334455" />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <div className="w-48">
                                            <label className="form-label">EMAIL <span className="text-danger">*</span></label>
                                            <input type="email" id="email_tutor" name="email_tutor" className="form-control" value={this.state.email_tutor} onChange={this.handleChange} required placeholder="Ejemplo: tutor@correo.com" />
                                        </div>
                                    </div>
                                </FormGroup>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-outline-success" onClick={this.actualizarTutor}>
                                    <i className="fas fa-save"></i> Guardar
                                </button>
                                <button className="btn btn-outline-danger" onClick={() => this.setState({ modalModTutor: false })}>
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}


